import { render, staticRenderFns } from "./PenaltiesContesting.vue?vue&type=template&id=6f16b3cf&scoped=true&"
import script from "./PenaltiesContesting.vue?vue&type=script&lang=js&"
export * from "./PenaltiesContesting.vue?vue&type=script&lang=js&"
import style0 from "./PenaltiesContesting.vue?vue&type=style&index=0&id=6f16b3cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16b3cf",
  null
  
)

export default component.exports